// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"79":"ade5355a","817":"ba5c44fa"}[chunkId] + ".chunk.css";
};